module.exports = __webpack_public_path__ + "img/34_43.10f51e80.png";